import * as fromContact from '../actions/contact.actions';
import { createSelector } from '@ngrx/store';
import { Pagination } from '../../shared/models/pagination';
export interface ContactState {
  contacts: any[];
  openContacts: any[];
  pagination: Pagination;  
  lastNewId : number;
  error: string;
}

const initState: ContactState = {
  contacts: [],
  openContacts: [],
  pagination: {
    sortField: '',
    sortOrder: 1,
    filters: null,
    first: 1,
    rows: 10,
    totalCount: 0,
  },
  lastNewId: -1,
  error: null,
};

export function contactReducer( state: ContactState = initState, action: fromContact.contactActions): ContactState {
    switch ( action.type ) {
     case fromContact.ADD_CONTACT: {
       return {
         ...state,
         lastNewId: state.lastNewId - 1,
         openContacts: [
           ...state.openContacts,
           Object.assign({id:state.lastNewId - 1, name: ''})
         ],         
       };
     }
    case fromContact.LOAD_CONTACTS: {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          sortField: action.sortField,
          sortOrder: action.sortOrder,
          filters: action.filters,
          first: action.first,
          rows: action.rows,
        }
      };      
    }
    case fromContact.LOAD_CONTACTS_ERROR: {
       return {
         ...state,
         error: action.error
       }
    }
    case fromContact.LOAD_CONTACTS_SUCCESS : {
      return {
        ...state,
        contacts: action.contacts,
        pagination: {
          ...state.pagination,
          totalCount: action.totalCount
        }
      };
    }
    case fromContact.OPEN_TAB : {
       if (state.openContacts.find(c => c.id == action.id)) {
         return {
           ...state
         };
       }
       return {
         ...state,
           openContacts: [
             ...state.openContacts,
             {
               id: action.id,
               name: 'Chargement...',
               loading: true,
             }
           ]
       };
    }   
     case fromContact.CLOSE_TAB:  {       
       return {
         ...state,
         openContacts: state.openContacts.filter(c => c.id.toString() !== action.id.toString())
       };
     }    

    case fromContact.LOAD_CONTACT_SUCCESS : {
       let oc = state.openContacts.map(c => {
         if (c.id == action.contact.id) {
           return action.contact;
         }
         return c;
       });
       return {
         ...state,
           openContacts: oc
       };
    }       
    
    case fromContact.SAVE_CONTACT : {
       const cs = state.openContacts.map(c =>{
         if (c.id.toString() === action.contact.id.toString()) {
           return Object.assign(action.contact, {saved:false});
         }
         return c;
       });
       return {
         ...state,
           openContacts: cs
       };
    }       
    case fromContact.SAVE_CONTACT_SUCCESS : {
      console.log("save contact success", action);
       const cs = state.openContacts.map(c =>{
         if (c.id.toString() === action.id.toString()) {
           return Object.assign(action.contact, {oldId: action.id, saved:true});
         }
         return c;
       });
       console.log(cs);
       return {
         ...state,
           openContacts: cs
       };
    }           
    case fromContact.SAVE_CONTACT_ERROR : {
       const cs = state.openContacts.map(c =>{
         if (c.id.toString() === action.id.toString()) {
           return Object.assign({}, c, {errors:action.error});
         }
         return c;
       });
       return {
         ...state,
           openContacts: cs
       };
    }               
    default:
        return state;
    }
}


export const selectContact = (state: any) => state.contact;
export const selectContacts = createSelector(selectContact, (exp) => exp && exp.contacts);
export const selectContactPagination = createSelector(selectContact, (exp) => exp && exp.pagination);
export const selectContactError = createSelector(selectContact, (exp) => exp && exp.error);
export const selectContactCount = createSelector(selectContact, (exp) => exp && exp.pagination && exp.pagination.totalCount);
export const selectOpenContacts = createSelector(
  selectContact,
  (contact) => {
    return contact && contact.openContacts;
  }
);

export const selectOpenContact = createSelector(
  selectContact,
  (contacts, props) => {    
    let ar = contacts.contacts.filter(e => e.id.toString() === props.id.toString());
    if (ar.length === 0) return null;
    return ar[0];
  }
);